import Vue from 'vue'
import VueRouter from 'vue-router'
import Content from '../views/content.vue'
import newMaterial from '@/views/newMaterial'
import Help from '../views/help.vue'
import Detail from '../views/detail.vue'
import Prize from '../views/prize.vue'
import Resource from '../views/resource.vue'
import ForgetPassword from '../views/forgetPassword.vue'
import Register from '../views/register.vue'
import Complete from '../views/complete.vue'
import userLayout from '@/components/userLayout'
import EditPassword from '../views/EditPassword.vue'
import Collect from '../views/collect.vue'
import newAboutUs from '@/views/newAboutUs'
import CopyRight from '@/views/copyRight'
import DownloadSection from '@/views/downloadSection'
import VideoOnlineLearning from '@/views/videoOnlineLearning'
import Preview from '@/views/preview'
import VideoResource from '@/views/videoResource.vue'
import VideoLearning from '@/views/videoLearning.vue'
import ScienceResource from '@/views/kxResource.vue'
import course from '@/views/course.vue'
import Cookies from 'js-cookie'
import store from '@/store'
import {educubeBinding, educubeLogin, getUser} from "@/api/user";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Content',
        meta: {home: true},
        component: Content
    },
    {
        path: '/material',
        name: 'Material',
        component: newMaterial
    },
    {
        path: '/help',
        name: 'help',
        component: Help
    },
    {
        path: '/detail',
        name: 'detail',
        component: Detail
    },
    {
        path: '/prize',
        name: 'prize',
        component: Prize
    },
    {
        path: '/prizeV1',
        name: 'prizeV1',
        component: () => import("@/views/prizeV1.vue"),
    },
    {
        path: '/course2',
        name: 'course2',
        meta: {hide: true},
        component: () => import("@/views/prizeV1Static.vue"),
    },
    {
        path: '/course3',
        name: 'course3',
        meta: {hide: true},
        component: () => import("@/views/course3.vue"),
    },
    {
        path: '/course4',
        name: 'course4',
        meta: {hide: true},
        component: () => import("@/views/course4.vue"),
    },
    {
        path: '/course5',
        name: 'course5',
        meta: {hide: true},
        component: () => import("@/views/course5.vue"),
    },
    {
        path: '/course6',
        name: 'course6',
        meta: {hide: true},
        component: () => import("@/views/course6.vue"),
    },
    {
        path: '/course7',
        name: 'course7',
        meta: {hide: true},
        component: () => import("@/views/course7.vue"),
    },
    {
        path: '/course8',
        name: 'course8',
        meta: {hide: true},
        component: () => import("@/views/course8.vue"),
    }, {
        path: '/course9',
        name: 'course9',
        meta: {hide: true},
        component: () => import("@/views/course9.vue"),
    },
    {
        path: '/resource',
        name: 'resource',
        component: Resource
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },
    {
        path: "/loginRegistration",
        name: "loginRegistration",
        component: () => import("@/views/loginRegistration"),
    },
    {
        path: '/forgetPassword',
        name: 'forgetPassword',
        component: ForgetPassword
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/complete',
        name: 'complete',
        component: Complete
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: userLayout
    },
    {
        path: '/editPassword',
        name: 'editPassword',
        component: EditPassword
    },
    {
        path: '/collect',
        name: 'collect',
        component: Collect
    },
    {
        path: '/about-us',
        name: 'aboutUs',
        component: newAboutUs
    },
    {
        path: '/copyRight',
        name: 'copyRight',
        component: CopyRight
    },
    {
        path: '/downloadSection',
        name: 'downloadSection',
        component: DownloadSection
    },
    {
        path: '/videoOnlineLearning',
        name: 'videoOnlineLearning',
        component: VideoOnlineLearning
    },
    {
        path: '/preview',
        name: 'preview',
        component: Preview
    },
    {
        path: '/videoResource',
        name: 'videoResource',
        component: VideoResource
    },
    {
        path: '/videoLearning',
        name: 'videoLearning',
        component: VideoLearning
    },
    {
        path: '/course',
        name: 'course',
        meta: {hide: true},
        component: course
    },
    {
      path: '/science-resource',
      name: 'scienceResource',
      meta: {navHide: true},
      component: ScienceResource
    },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 路由拦截器
router.beforeEach(async (to, from, next) => {
    try {
        document.title = to.name === 'course' ? '历程' : '浙江省数字教材服务平台'
        document.title = to.name === 'course2' ? '下姜村的共同富裕梦' : '浙江省数字教材服务平台'
        const {sessionId, unionId, isBound, userId, token} = to.query
        if (sessionId) {
            store.commit('setCubeUser', {sessionId})
            await educubeLogin({sessionId}, {noShowErrorMsg: true}).then(async res => {
                store.commit('setUser', res.data)
                const userInfo = res.data
                Cookies.set('token', res.data.token)
                const zsUser = await getUser(res.data.userId)
                Object.assign(userInfo, zsUser.data)
                store.commit('setUser', userInfo)
                next(to.path)
            }).catch(async err => {
                {
                    if (err.data && err.data.data) {
                        store.commit('setCubeUser', {cubeAccountId: err.data.data.cubeAccountId})
                    }
                    if (err.data && err.data.errorCode === 'EDU.ACCOUNT_NOT_BOUND') {
                        if (localStorage.user) {
                            const userId = JSON.parse(localStorage.user).userId
                            if (userId && to.path === '/userInfo') {
                                await educubeBinding({
                                    cubeAccountId: err.data.data.cubeAccountId,
                                    userId: userId,
                                }, {noShowErrorMsg: true}).finally(async () => {
                                    next(to.path)
                                })
                            } else {
                                next('/loginRegistration?loginStep=8')
                            }
                        } else {
                            next('/loginRegistration?loginStep=8')
                        }
                    }
                }
            })
        }
        if (unionId) {
            store.commit('setWxUser', {unionId})
            if (isBound === 'false') {
                //wx登录未绑定
                next('/loginRegistration?loginStep=9&unionId=' + unionId+'&isTeacher=false')
            } else {
                if (token) {
                    Cookies.set('token', token)
                    const zsUser = await getUser(userId)
                    store.commit('setUser', zsUser.data)
                    next('/')
                }
            }
        }
        if (localStorage.user && localStorage.user.userId) {
            store.commit('setUser', JSON.parse(localStorage.user))
        } else if (Cookies.get('commonName', {domain: 'zjeav.com'})) {
            const user = Cookies.get('commonName', {domain: 'zjeav.com'})
            store.commit('setUser', JSON.parse(user))
        } else if (/token=\w+/.test(location.hash)) {
            const token = location.hash.match(/(\?|&)token=([^&]+)/)[2]
            const userId = location.hash.match(/(\?|&)userId=([^&]+)/)[2]
            const userName = location.hash.match(/(\?|&)userName=([^&]+)/)[2]
            store.commit('setUser', {token, userId, userName})
        }
    } catch (e) {
    }
    next()
})

export default router
